











































import {Vue, Component, Prop} from 'vue-property-decorator';
import {PayrollReport} from "@/components/payroll/business/employments/employee/PayrollReport";
import PaystubReport from "@/components/payroll/reports/paystub/PaystubReport.vue";
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";
import moment from "moment";
import {prettyEnum} from "@/utils/StringUtils";
import PayrollDetailsReport from "@/components/payroll/reports/payroll_details/PayrollDetailsReport.vue";

@Component({
	computed: {
		moment() {
			return moment
		}
	},
	methods: {
		prettyEnum(val: string) {
			return prettyEnum(val)
		}
	},
	components: {PayrollDetailsReport, BTPortalCollapse, PaystubReport}
})
export default class CollapsedPayrollDetailsReport extends Vue {

	@Prop()
	private report!: PayrollReport

}
